import MixinConfirm from '@/components/mixins/MixinConfirm';

export default {
    mixins: [MixinConfirm],
    methods: {

        apiDelete(url, confirm, params) {
            return new Promise((resolve, reject) => {
                this.openConfirm(this.$t(confirm)).then((response) => {
                    if (response) {
                        this.$http.delete(url, null, true, true).then((response) => {
                            if (response.success) {
                                resolve(true)
                            } else {
                                reject();
                            }
                        });
                    }
                });
            })

        },
    }

}